module.exports = __webpack_public_path__ + "static/media/the_carbon_challenge_mobile.c13cac7d.jpg";